import { useProductSummary } from '../hooks/useProductSummary';

type ElementProps = { children: React.ReactNode };

const Element = ({ children }: ElementProps) => {
	const { blockClass } = useProductSummary();

	return (
		<article
			className={`element element--${blockClass} vtex-product-summary-2-x-element vtex-product-summary-2-x-element--${blockClass} pointer pt3 pb4 flex flex-column h-100`}
		>
			{children}
		</article>
	);
};

export default Element;
